import Vue from 'vue';
import {PlacetelCallEventPayload, PlacetelEvents} from '@/enums/notifier/serviceEvents/PlacetelEvents';

interface PlacetelCallBus {
    $emit(event: PlacetelEvents, payload: PlacetelCallEventPayload): void;

    $on(event: PlacetelEvents, callback: (payload: PlacetelCallEventPayload) => void): void;

    $off(event: PlacetelEvents, callback: (payload: PlacetelCallEventPayload) => void): void;
}

/** Live Placetel call events from the notifier socket (Anruf-Fenster) */
export const PlacetelCallBus: PlacetelCallBus = new Vue();
